
<template>
    <AppPermission :permission="this.$permissions.requests.data?? '' ">
        <div class="container">
            <div class="row m-0 p-0">
                <div class="mainLeft pt-3">
                    <div class="main-title">
                        <span>{{$t('message.RequestIndex.title')}}</span>
                    </div>
                    <div>
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row">
                            <div class="col-8 text-title">
                                <label>{{ $t('message.common.numberRecord') }}:</label>
                            </div>
                            <div class="col-4">
                                <select :value="numberRecord" name="number_records" id="number_records" class="number_records" @change="onChange($event)">
                                <option value="15">15</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                </select>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="card" id="typeCard">
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row mx-2">
                                <div class="col-9">
                                    <label class="typeTitle">{{ $t('message.RequestIndex.filter_time') }}</label>
                                </div>
                                <div class="col-1">
                                    <a href="javascript:void(0);" class="text-dark" id="linkIcon" @click="showHide('timeBody', 'timeDown', 'timeUp')">
                                        <i class="fa fa-chevron-down dp-hide" id="timeDown"></i>
                                        <i class="fa fa-chevron-up" id="timeUp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body my-0 py-2" id="timeBody">
                            <div class="row">
                                <div class="col-12 d-flex align-items-center">
                                    <label class="container-checkbox">{{ $t('message.RequestIndex.request_date') }}
                                        <input type="checkbox" class="chkType" @click="changeSelect('deliveryDate')" :checked="this.optionSelect.deliveryDate">
                                        <span class="checkmark-checkbox"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12 d-flex align-items-center">
                                    <label class="container-checkbox">{{ $t('message.RequestIndex.receive_date') }}
                                        <input type="checkbox" class="chkType" @click="changeSelect('receivedDate')" :checked="this.optionSelect.receivedDate">
                                        <span class="checkmark-checkbox"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-2 pl-2 d-flex align-items-center">
                                    <label class="container-radio ml-2">
                                        <input type="radio" v-model="sortTime" name="exampleRadios" id="exampleRadios1" :value="0" class="mr-2" @click="refreshDatePicker(0)">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-10 pl-0">
                                    <DateRangePicker :formatType="'YYYY-MM-DD'" @picker="filterTime"></DateRangePicker>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-2 pl-2 d-flex align-items-center">
                                    <label class="container-radio ml-2">
                                        <input type="radio" v-model="sortTime" name="exampleRadios" id="exampleRadios2" :value="1" class="mr-2" @click="refreshDatePicker(1)">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-10 pl-0">
                                    <InputDateRangePicker :sortTimeHeight="true" :defaultDate="true" :placeholder="$t('message.SelectDateTime.otherOption')" class="w-100 mb-0 custom-input"
                                    @input="filterTime(filter.timePicker, 1)" v-model="filter.timePicker"/>
                                    <!-- <i class="far fa-calendar fa-md icon-calendar" aria-hidden="true"></i> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-4" id="typeCard">
                        <div class="card-header mx-0 px-0 pb-0" id="typeHeader">
                            <div class="row mx-2">
                                <div class="col-9">
                                    <label class="typeTitle">{{ $t('message.RequestIndex.type') }}</label>
                                </div>
                                <div class="col-1">
                                    <a href="javascript:void(0);" class="text-dark" id="linkIcon" @click="showHide('typeBody', 'typeDown', 'typeUp')">
                                        <i class="fa fa-chevron-down dp-hide" id="typeDown"></i>
                                        <i class="fa fa-chevron-up" id="typeUp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body my-0 py-2" id="typeBody">
                            <div class="row">
                                <div class="col-12 d-flex align-items-center">
                                    <label class="container-checkbox">{{ $t('message.RequestIndex.type_transfer') }}
                                        <input type="checkbox" class="chkType" @click="changeSelect('transferBranch')" :checked="this.optionSelect.transferBranch">
                                        <span class="checkmark-checkbox"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <SelectSearch :placeholder="$t('message.RequestIndex.placeholder.to_branch')" :disabled="!this.optionSelect.transferBranch" :modelValue="filter.transferToBranch" :defaultOption="this.branches" @update:modelValue="doFilterSearch" :label="'toBranch'"></SelectSearch>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12 d-flex align-items-center">
                                    <label class="container-checkbox">{{ $t('message.RequestIndex.type_receive') }}
                                        <input type="checkbox" class="chkType" @click="changeSelect('requestBranch')" :checked="this.optionSelect.requestBranch">
                                        <span class="checkmark-checkbox"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-12">
                                    <SelectSearch :placeholder="$t('message.RequestIndex.placeholder.from_branch')" :disabled="!this.optionSelect.requestBranch" :modelValue="filter.requestToBranch" :defaultOption="this.branches" @update:modelValue="doFilterSearch" :label="'fromBranch'"></SelectSearch>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-4" id="typeCard">
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row mx-2">
                                <div class="col-9">
                                    <label class="typeTitle">{{ $t('message.RequestIndex.status') }}</label>
                                </div>
                                <div class="col-1">
                                    <a href="javascript:void(0);" class="text-dark" id="linkIcon" @click="showHide('statusBody', 'statusDown', 'statusUp')">
                                        <i class="fa fa-chevron-down dp-hide" id="statusDown"></i>
                                        <i class="fa fa-chevron-up" id="statusUp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body my-0 pt-0 pb-2" id="statusBody">
                            <div class="row" v-for="status in this.listStatusTransfer" :key="status.id">
                                <div class="col-12 d-flex align-items-center">
                                <label class="container-checkbox">{{status.name}}
                                    <input type="checkbox" class="chkType" @click="doFilter('status', status.id)" :checked="isExistInArrayChecked(status, this.filterQuery.status)">
                                    <span class="checkmark-checkbox"></span>
                                </label>
                            </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-4" id="typeCard">
                        <div class="card-header mx-0 px-0" id="typeHeader">
                            <div class="row mx-2">
                                <div class="col-9">
                                    <label class="typeTitle">{{ $t('message.RequestIndex.status_confirm') }}</label>
                                </div>
                                <div class="col-1">
                                    <a href="javascript:void(0);" class="text-dark" id="linkIcon" @click="showHide('status', 'sttDown', 'sttUp')">
                                        <i class="fa fa-chevron-down dp-hide" id="sttDown"></i>
                                        <i class="fa fa-chevron-up" id="sttUp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body my-0 py-2" id="status">
                            <div class="row ml-0" v-for="option in this.optionSttGive" :key="option.id">
                                <label class="container-radio ml-0">{{option.label}}
                                    <input type="radio" name="sttGive" v-model="this.filterQuery.receiveStatus" :checked="this.filterQuery.receiveStatus === option.value" :value="option.value" class="cheker mr-2" @change="doFilter('receiveStatus', option.value)">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="mainRight">
                    <div class="sticky-top pt-3">
                        <div class="row">
                            <div class="col-lg-5">
                                <InputQuickSearch :placeholder="$t('message.RequestIndex.placeholder.search')" @filterSearch="changeQuickSearch" :requestSearch="true"></InputQuickSearch>
                            </div>
                            <div class="col-lg-7 d-flex justify-content-end">
                            
                                <button type="button" @click="clearFilter()" class="btn btn-default">
                                    <i class="fa fa-filter mr-1"></i>
                                    {{ $t('message.button.removeFilter') }}
                                </button>
                                <div class="dropdown" v-if="this.arrayChecked?.length > 0 && entries?.length > 0">
                                    <button class="btn btn-save dropdown-toggle" type="button" id="dropdownMenuButton"
                                        style="padding:7px" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-ellipsis-v px-2"></i>
                                        {{ $t('message.RequestIndex.button.action') }}
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <AppPermission :permission="this.$permissions.requests.export?? '' ">
                                            <a class="dropdown-item" @click="exSelectOverview()">
                                                <i class="fa fa-share"></i>
                                                {{ $t('message.RequestIndex.button.export_all') }}
                                            </a>
                                            <a class="dropdown-item" @click="exSelectDetails()">
                                                <i class="fas fa-file-export"></i>
                                                {{ $t('message.RequestIndex.button.export_detail') }}
                                            </a>
                                        </AppPermission>
                                        <a class="dropdown-item" @click="sendMailAndZalo()" v-if="this.statusEmail">
                                            <i class="fa fa-share"></i>
                                            {{ $t('message.button.sendMailText') }}
                                        </a>
                                    </div>
                                </div>
                                <AppPermission :permission="this.$permissions.requests.create?? '' ">
                                <button class="btn btn-save ml-1" @click="createTicket">
                                    <i class="fa fa-plus"></i> 
                                    {{ $t('message.RequestIndex.button.create') }}
                                </button>
                                </AppPermission>
                                <AppPermission :permission="this.$permissions.requests.export?? '' ">
                                <div class="dropdown">
                                    <button class="btn btn-save dropdown-toggle" type="button" id="dropdownMenuButton"
                                        style="padding:7px" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-file-export px-2"></i>
                                        {{ $t('message.RequestIndex.button.export') }}
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#" @click="selectOptionExport('exOverview')">
                                            {{ $t('message.RequestIndex.button.file_all') }}
                                        </a>
                                        <a class="dropdown-item" href="javascript:;" @click="selectOptionExport('exDetails')">
                                            {{ $t('message.RequestIndex.button.file_detail') }}
                                        </a>
                                    </div>
                                </div>
                                </AppPermission>
                                <div id="loc" v-on:mouseleave="onMouseLeave">
                                    <SelectField :fields="fields" label="request"></SelectField>
                                </div>                            
                            </div>
                        </div>
                        <div>
                            <Pagination :value="paginate" :record="this.numberRecord" @change="pageChange"/>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                <div class="col-12" v-if="this.arrayChecked?.length > 0 && entries?.length > 0">
                                    {{ $t('message.common.numberRecordSelected', {number: this.arrayChecked?.length}) }}
                                    <a href="javascript:;" @click="removeChecked()">
                                        <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <div class="row mx-0 my-2" v-if="entries.length > 0" id="divTable">
                                    <table class="table table-index table-striped lstProduct">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="checkbox-table"><input v-model="checkedAll" @change="onCheckedAll(checkedAll)" type="checkbox"/></th>
                                                <template v-for="field in fields" :key="field.field">
                                                    <th scope="col" v-if="field.selected" style="vertical-align: middle !important;">
                                                        <TableSortField :current="sortData.field" :no-sort="!field.isColumn" @onsort="sort"
                                                                        :class="field.class" :name="field.name" :field="field.field" :style="field.style"  />
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(entry, index) in entries" :key="entry.id" >
                                                <tr class="master-row" :style="index % 2 ? 'background-color: white' : null" :class="entry.id === this.transferActive ? 'backgroup__detail border__master' :''" :id="'row_' + (index + 1)">
                                                        <td>
                                                            <input v-model="entry.checked" type="checkbox"  @change.stop="countChecked(entry.id)" class="prdChecked"
                                                                    :id="entry.id" :name="entry.name" :value="entry.code" :checked="isExistInArrayChecked(entry, this.arrayChecked)">
                                                        </td>
                                                        <template v-for="field in fields" :key="field.field">
                                                            <td class="ow-break-word py-0" v-if="field.selected" style="vertical-align:middle !important;" :style="'min-width:110px'">
                                                                <a :href="'#row_' + index" class="description text-dark tagA" @click="detailRequest(entry.id, entry)">
                                                                <div v-if="field.field==='fromBranch'" :style="field.style" class="description"><span v-text="entry.from_branch?.name"></span></div>      
                                                                <div v-else-if="field.field==='toBranch'" :style="field.style" class="description"><span v-text="entry.to_branch?.name"></span></div>
                                                                <div v-else-if="field.field==='createdByName'" :style="field.style" class="description"><span v-text="entry.created_by_user?.name"></span></div>
                                                                <div v-else-if="field.field==='receivedBy'" :style="field.style" class="description"><span v-text="entry.get_transfer?.received_by_user?.name"></span></div>
                                                                <div v-else-if="field.field==='status'" :style="field.style" class="description"><span v-text="entry.statusName"></span></div>
                                                                <div v-else-if="field.field==='totalSendQuantity'" :style="field.style" class="description"><span v-text="n(entry.totalSendQuantity)"></span></div>
                                                                <div v-else-if="field.field==='sendPrice'" :style="field.style" class="description"><span v-text="n(entry.sendPrice)"></span></div>
                                                                <div v-else-if="field.field==='totalReceiveQuantity'" :style="field.style" class="description"><span v-text="n(entry.totalReceiveQuantity)"></span></div>
                                                                <div v-else-if="field.field==='receivePrice'" :style="field.style" class="description"><span v-text="n(entry.receivePrice)"></span></div>
                                                                <div v-else-if="field.field==='totalProduct'" :style="field.style" class="description"><span v-text="n(entry.totalProduct)"></span></div>
                                                                <div v-else-if="field.field==='deliveryDate'" :style="field.style" class="description"><span v-text="dt(entry.deliveryDate)"></span></div>
                                                                <div v-else-if="field.field==='receivedDate'" :style="field.style" class="description"><span v-text="dt(entry.receivedDate)"></span></div>
                                                                <div v-else-if="field.field==='createdAt'" :style="field.style" class="description"><span v-text="dt(entry.createdAt)"></span></div>
                                                                <div v-else v-text="renderField(entry, field.field, field)" :title="renderField(entry, field.field, field)" :style="field.style" class="description" :class="field.class"></div>
                                                                </a>
                                                            </td>
                                                        </template>
                                                </tr>
                                                <tr v-if="transferActive === entry.id" :class="[ entry.id === transferActive ? 'backgroup__detail border__header-detail' : '', errorClass]">
                                                    <td></td>
                                                    <td :colspan="fields.length" class="pb-0">
                                                        <div class="row detail-prd-row">
                                                            <div class="col-2 mt-2">
                                                                <span class="backgroup__detail-active head-detail">
                                                                    <span v-if="this.branchId === entry.fromBranchId">
                                                                        {{ $t('message.RequestIndex.tabs.info') }}
                                                                    </span>
                                                                    <span v-else>
                                                                        {{ $t('message.RequestIndex.tabs.detail') }}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <!-- Chi tiết phiếu chuyển hàng -->
                                                <tr class="detail-row bg-white border__body-detail" v-if="transferActive === entry.id">
                                                    <td></td>
                                                    <td :colspan="fields.length" class="border-top-0">
                                                        <div class="mt-2 pb-4 detail__user">
                                                            <div class="row mt-2 detail-prd-row">
                                                                <div class="col-4">
                                                                    <div class="row border-bottom-1 mt-2 py-2">
                                                                        <div class="col-5">
                                                                            {{$t('message.RequestIndex.request_code')}}:
                                                                        </div>
                                                                        <div class="col-7 ow-break-word">                                                            
                                                                            <b>{{ entry.code }}</b>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row border-bottom-1 mt-2 py-2">
                                                                        <div class="col-5 lableOS">
                                                                            {{$t('message.RequestIndex.from_branch')}}:
                                                                        </div>
                                                                        <div class="col-7 ow-break-word lableOS pr-0">                                                            
                                                                            {{ entry.from_branch?.name }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="row border-bottom-1 mt-2 py-2">
                                                                        <div class="col-5">
                                                                            {{$t('message.RequestIndex.to_branch')}}:
                                                                        </div>
                                                                        <div class="col-7 ow-break-word">
                                                                            <!-- <InputSelectSearch :defaultValue="'Chọn chi nhánh'" :modelValue="entry.toBranchId" :defaultOption="branches" @update:modelValue="resetValue"
                                                                            v-if="entry.statusOrigin == this.$constant.statusTransferDraft"></InputSelectSearch>
                                                                            <span v-else>{{ entry.to_branch?.name }}</span> -->
                                                                            {{ entry.to_branch?.name }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="row border-bottom-1 mt-2 py-2">
                                                                        <div class="col-5">
                                                                            {{$t('message.RequestIndex.filter_user')}}:
                                                                        </div>
                                                                        <div class="col-7 ow-break-word">
                                                                            {{ entry.created_by_user?.name }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-4">
                                                                    <div class="mx-1">
                                                                        <div class="col-12">
                                                                            <div class="row border-bottom-1 mt-2 py-2">
                                                                                <div class="col-5">
                                                                                    {{$t('message.RequestIndex.transfer_code')}}:
                                                                                </div>
                                                                                <div class="col-7 ow-break-word">
                                                                                    {{ entry.get_transfer?.code }}
                                                                                </div>
                                                                            </div>
                                                                            <div class="row border-bottom-1 mt-2 py-2">
                                                                                <div class="col-5">
                                                                                    {{$t('message.RequestIndex.request_date')}}:
                                                                                </div>
                                                                                <div class="col-7 ow-break-word">
                                                                                    {{ dt(entry.deliveryDate) }}
                                                                                </div>
                                                                            </div>
                                                                            <div class="row border-bottom-1 mt-2 py-2">
                                                                                <div class="col-5">
                                                                                    {{$t('message.RequestIndex.receive_date')}}:
                                                                                </div>                                                                
                                                                                <div class="col-7 ow-break-word">                                                                    
                                                                                    {{ dt(entry.receivedDate) }}
                                                                                </div>
                                                                            </div>
                                                                            <div class="row border-bottom-1 mt-2 py-2">
                                                                                <div class="col-5 lableOS">
                                                                                    {{$t('message.RequestIndex.status')}}:
                                                                                </div>
                                                                                <div class="col-7 ow-break-word">
                                                                                    {{ entry.statusName }}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-4 font-italic" id="noteRO">  
                                                                    <div class="row p-0 h-50">
                                                                        <div class="col-12" v-if="this.branchId === entry.fromBranchId && entry.statusOrigin == $constant.statusTransferDraft">
                                                                            <textarea v-model="entry.receiveDescription" :id="'note_'+ entry.id" :placeholder="$t('message.RequestIndex.from_branch_note')" class="noteStyle px-4 text-gray font-italic"></textarea>
                                                                            <i class="fa fa-pencil-alt text-gray" id="fa_edit"></i>
                                                                        </div>
                                                                        <div class="col-12" v-else>
                                                                            <span :class="this.branchId === entry.fromBranchId ? 'text-gray' : ''">
                                                                                {{ entry.receiveDescription ? entry.receiveDescription : $t('message.RequestIndex.from_branch_note')}}
                                                                            </span>
                                                                        </div>
                                                                    </div>                                                     
                                                                    <div class="row p-0 h-50">
                                                                        <div class="col-12" v-if="this.branchId === entry.toBranchId && entry.statusOrigin == $constant.statusTransferDraft">
                                                                            <textarea v-model="entry.sendDescription" :id="'note_'+ entry.id" :placeholder="$t('message.RequestIndex.to_branch_note')" class="noteStyle px-4 text-gray font-italic"></textarea>
                                                                            <i class="fa fa-pencil-alt text-gray" id="fa_edit"></i>
                                                                        </div>
                                                                        <div class="col-12" v-else>
                                                                            <span :class="this.branchId === entry.toBranchId ? 'text-gray' : ''">
                                                                                {{ entry.sendDescription ? entry.sendDescription : $t('message.RequestIndex.to_branch_note')}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <!-- Chi tiet san pham va gia -->
                                                <tr class="detail-row bg-white border__body-detail" v-if="transferActive === entry.id">
                                                    <td :colspan="fields.length" class="border-top-0">
                                                        <div class="mt-2 pb-4 detail__user">
                                                            <div class="row mt-2 detail-prd-row detail-prd-table pl-2">
                                                                <div class="col-12 pl-0">
                                                                    <table class="w-100">
                                                                        <thead>
                                                                            <tr class="backgroup__detail">
                                                                                <template v-for="fieldDetail in this.fieldTransferDetail" :key="fieldDetail">
                                                                                    <th scope="col" class="pl-4" v-if="fieldDetail.selected || entry.get_transfer != null" :style="fieldDetail.style ? fieldDetail.style : ''">
                                                                                        <div v-if="fieldDetail.field == 'receiveQuantity' && this.branchId === entry.fromBranchId" v-text="fieldDetail.name"></div>
                                                                                        <div v-else-if="fieldDetail.field == 'receiveQuantity' && this.branchId != entry.fromBranchId" v-text="$t('message.RequestIndex.sendQuantity')"></div>
                                                                                        <div v-else-if="fieldDetail.field == 'receiveSubTotal' && this.branchId === entry.fromBranchId" v-text="fieldDetail.name"></div>
                                                                                        <div v-else-if="fieldDetail.field == 'receiveSubTotal' && this.branchId != entry.fromBranchId" v-text="$t('message.RequestIndex.sendAmount')"></div>
                                                                                        <div v-else-if="fieldDetail.field == 'price' && this.branchId === entry.fromBranchId" v-text="fieldDetail.name"></div>
                                                                                        <div v-else-if="fieldDetail.field == 'price' && this.branchId != entry.fromBranchId" v-text="$t('message.RequestIndex.requestPriceOrSendPrice')"></div>
                                                                                        <div v-else v-text="fieldDetail.name"></div>
                                                                                    </th>
                                                                                </template>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr class="bg-white">
                                                                                <th scope="col" class="pl-4"> 
                                                                                    <input type="text" v-model="this.defaultTransfer.searchCode" @input="onInputFilterTransferDetail('searchCode')" :placeholder="$t('message.DetailOrdersCard.searchProductCode')" class="border-none bg-transparent h-100">
                                                                                </th>
                                                                                <th scope="col" class="pl-4"> 
                                                                                    <input type="text" v-model="this.defaultTransfer.searchName" @input="onInputFilterTransferDetail('searchName')" :placeholder="$t('message.DetailOrdersCard.searchProductName')" class="border-none bg-transparent h-100">
                                                                                </th>
                                                                                <th scope="col" class="pl-4" :colspan="fieldTransferDetail.length - 2"> 
                                                                                </th>
                                                                            </tr>
                                                                            <template v-if="this.defaultTransfer.filter?.length > 0">
                                                                                <template v-for="(transferDetail, index) in this.defaultTransfer.filter" :key="transferDetail.id">
                                                                                    <template  v-if="index >= (this.paginateDetail.currentPage - 1)*10 && index < this.paginateDetail.currentPage*10">
                                                                                        <tr>
                                                                                            <td v-text="transferDetail.productCode" class="pl-4"></td>
                                                                                            <td class="pl-4">
                                                                                                <div class="row p-0 m-0">
                                                                                                    <div class="col-12" v-text="transferDetail.productName"></div>
                                                                                                    <div class="col-12 description font-italic text-gray" v-text="transferDetail.receiveDescription" :title="transferDetail.receiveDescription"></div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td v-text="transferDetail.product_unit ? transferDetail.product_unit.unitName : ''" class="pl-4 text-left"></td>
                                                                                            <!-- <td v-text="transferDetail.variant ? transferDetail.variant.name : ''" class="pl-4 text-left"></td> -->
                                                                                            <td v-text="transferDetail?.attributeName ? transferDetail.attributeName : '' " class="pl-4"></td>
                                                                                            <td v-text="n(transferDetail.receiveQuantity)" class="pl-4 text-right"></td>
                                                                                            <td v-text="n(transferDetail.sendQuantity)" class="pl-4 text-right" v-if="entry.get_transfer != null"></td>
                                                                                            <td v-text="n(transferDetail.price)" class="pl-4 text-right"></td>
                                                                                            <td class="pl-4 text-right">
                                                                                                {{ n(transferDetail.receivePrice) }}
                                                                                            </td>
                                                                                            <td class="pl-4 text-right" v-if="entry.get_transfer != null">
                                                                                                {{ n(transferDetail.sendPrice) }}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template>
    
                                                                                    <template v-if="transferDetail.plus && transferDetail.plus?.length > 0">
                                                                                        <template v-for="(plusItem, indexPlus) in transferDetail.plus" :key="indexPlus">
                                                                                            <tr>
                                                                                                <td v-text="transferDetail.productCode" class="pl-4"></td>
                                                                                                <td class="pl-4">
                                                                                                    <div class="row p-0 m-0">
                                                                                                        <div class="col-12" v-text="transferDetail.productName"></div>
                                                                                                        <div class="col-12 description font-italic text-gray" v-text="transferDetail.receiveDescription" :title="transferDetail.receiveDescription"></div>
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td v-text="plusItem.product_unit ? plusItem.product_unit.unitName : ''" class="pl-4 text-left"></td>
                                                                                                <!-- <td v-text="plusItem.variant ? plusItem.variant.name : ''" class="pl-4 text-left"></td> -->
                                                                                                <td v-text="plusItem?.attributeName ? plusItem.attributeName : '' " class="pl-4"></td>
                                                                                                <td v-text="n(plusItem.receiveQuantity)" class="pl-4 text-right"></td>
                                                                                                <td v-text="n(plusItem.sendQuantity)" class="pl-4 text-right" v-if="entry.get_transfer != null"></td>
                                                                                                <td v-text="n(plusItem.price)" class="pl-4 text-right"></td>
                                                                                                <td class="pl-4 text-right">
                                                                                                    {{ n(plusItem.receivePrice) }}
                                                                                                </td>
                                                                                                <td class="pl-4 text-right" v-if="entry.get_transfer != null">
                                                                                                    {{ n(plusItem.sendPrice) }}
                                                                                                </td>
                                                                                            </tr>
                                                                                        </template>
                                                                                    </template>
                                                                                </template>
                                                                                <!-- <tr v-for="(transferDetail, index) in this.defaultTransfer.filter" :key="transferDetail.id" :class="index % 2 ? 'bg-white' : 'bg-light'">
                                                                                    <template v-if="index >= (this.paginateDetail.currentPage - 1)*10 && index < this.paginateDetail.currentPage*10">
                                                                                        <td v-text="transferDetail.productCode" class="pl-4"></td>
                                                                                        <td class="pl-4">
                                                                                            <div class="row p-0 m-0">
                                                                                                <div class="col-12" v-text="transferDetail.productName"></div>
                                                                                                <div class="col-12 description font-italic text-gray" v-text="transferDetail.receiveDescription" :title="transferDetail.receiveDescription"></div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td v-text="n(transferDetail.receiveQuantity)" class="pl-4 text-right"></td>
                                                                                        <td v-text="n(transferDetail.sendQuantity)" class="pl-4 text-right" v-if="entry.get_transfer != null"></td>
                                                                                        <td v-text="n(transferDetail.price)" class="pl-4 text-right"></td>
                                                                                        <td class="pl-4 text-right">
                                                                                            {{ n(transferDetail.receivePrice) }}
                                                                                        </td>
                                                                                        <td class="pl-4 text-right" v-if="entry.get_transfer != null">
                                                                                            {{ n(transferDetail.sendPrice) }}
                                                                                        </td>
                                                                                    </template>
                                                                                </tr> -->
                                                                            </template>
                                                                            <template v-else>
                                                                                <tr class="text-center bg-light">
                                                                                    <td :colspan="fieldTransferDetail.length">{{$t('message.common.notFound')}}</td>
                                                                                </tr>
                                                                            </template>
                                                                        </tbody>
                                                                    </table>
                                                                    <Pagination :value="paginateDetail" :record="10" v-if="this.paginateDetail.totalRecord >= 10"/>
                                                                </div>
                                                            </div>
                                                            <div class="row detail-prd-row mt-4 pr-4">
                                                                <div class="col-10 flex-end">{{$t('message.RequestIndex.total_products')}}:</div>
                                                                <div class="col-2 flex-end">{{ entry.totalProduct }}</div>
                                                            </div>
                                                            <div class="row detail-prd-row mt-2 pr-4">
                                                                <div class="col-10 flex-end">{{$t('message.RequestIndex.total_request_quantity')}}:</div>
                                                                <div class="col-2 flex-end">{{ entry.totalReceiveQuantity }}</div>
                                                            </div>
                                                            <div class="row detail-prd-row mt-2 pr-4">
                                                                <div class="col-10 flex-end">{{$t('message.RequestIndex.total_request_price')}}:</div>
                                                                <div class="col-2 flex-end">{{ n(entry.receivePrice) }}</div>
                                                            </div>
                                                            <div class="row detail-prd-row mt-2 pr-4" v-if="entry.get_transfer != null">
                                                                <div class="col-10 flex-end">{{ this.branchId === entry.fromBranchId ? $t('message.RequestIndex.total_confirm_quantity')  : $t('message.RequestIndex.total_transfer_quantity')}}</div>
                                                                <div class="col-2 flex-end">{{ entry.totalSendQuantity }}</div>
                                                            </div>
                                                            <div class="row detail-prd-row mt-2 pr-4" v-if="entry.get_transfer != null">
                                                                <div class="col-10 flex-end">{{ this.branchId === entry.fromBranchId ? $t('message.RequestIndex.total_confirm_price')  : $t('message.RequestIndex.total_transfer_price')}}</div>
                                                                <div class="col-2 flex-end">{{ n(entry.sendPrice) }}</div>
                                                            </div>
                                                            <div class="row detail-prd-row flex-end mt-4 pr-4" >
                                                                <AppPermission :permission="this.$permissions.requests.update?? '' ">
                                                                    <button v-if="entry.statusOrigin == $constant.statusTransferDraft" type="button" class="btn btn-save mx-1" @click="quickSaveTransfer(entry)">
                                                                        <i class="fa fa-save"></i>
                                                                        {{$t('message.RequestIndex.button.save')}}
                                                                    </button>
                                                                
                                                                    <button v-if="entry.statusOrigin == $constant.statusTransferDraft && branchId === entry.fromBranchId" type="button" class="btn btn-save mx-1" @click="editTicket(entry.id)">
                                                                        <i class="fa fa-share"></i>
                                                                        {{$t('message.RequestIndex.button.open')}}
                                                                    </button>
                                                                    <button v-if="entry.statusOrigin == $constant.statusTicketTransferTransported && branchId === entry.toBranchId" type="button" class="btn btn-save mx-1" @click="confirmTicket(entry.id)">
                                                                        <i class="fa fa-share"></i>
                                                                        {{$t('message.RequestIndex.button.process')}}
                                                                    </button>
                                                                 </AppPermission>
                                                                <!-- <button type="button" class="btn btn-secondary text-white mx-1" @click="getTemplatePrint(entry)">
                                                                    <i class="fa fa-print" aria-hidden="true"></i>
                                                                    In
                                                                </button> -->
                                                                <!-- <button type="button" class="btn btn-secondary text-white mx-1">
                                                                    <i class="fa fa-barcode"></i>
                                                                    In tem mã
                                                                </button> -->
                                                                <AppPermission :permission="this.$permissions.requests.export?? '' ">
                                                                <button type="button" class="btn btn-secondary text-white mx-1"  @click="exRequestById(entry.id)">
                                                                    <i class="fa fa-file-export" aria-hidden="true"></i>
                                                                    {{$t('message.RequestIndex.button.export')}}
                                                                </button>                                                        
                                                                </AppPermission>
                                                                <AppPermission :permission="this.$permissions.requests.create?? '' ">
                                                                <button type="button" class="btn btn-save mx-1" @click="copyRequestById(entry.id)" v-if="this.branchId == entry.fromBranchId">
                                                                    <i class="fa fa-copy" aria-hidden="true"></i>
                                                                    {{$t('message.RequestIndex.button.copy')}}
                                                                </button>
                                                                </AppPermission>
                                                                <AppPermission :permission="this.$permissions.requests.cancel?? '' ">
                                                                <button v-if="entry.statusOrigin == $constant.statusTransferDraft || entry.statusOrigin == $constant.statusTransferInProgress" type="button" class="btn btn-danger mx-1"  @click="ShowModalRequestAbort(entry.id, entry.code)">
                                                                    <i class="fa fa-trash-alt"></i>
                                                                    {{$t('message.RequestIndex.button.cancel')}}
                                                                </button>
                                                                </AppPermission>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="detail-row bg-white border__footer-detail" v-if="transferActive === entry.id"></tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="row ml-auto mr-auto" v-if="entries.length == 0 && !this.loading" id="notFound">
                                    <div class="col-sm-12 text-center my-10 text-secondary align-items-center d-flex justify-content-center">
                                        <i class="fa fa-hdd-o mr-2 text-secondary"></i>
                                        <!-- <p>{{$t('message.common.notFound')}}</p> -->
                                        <p>{{ !this.isFilter ? $t('message.common.notData') :  $t('message.common.notFound')}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalRequestAbort ref="ModalRequestAbort"  @inputData="load()"/>
        <ModalSelectPrintTemplate ref="ModalSelectPrintTemplate" @updateContent="updateContent"/>
        <PrintTemplate ref="PrintTemplate" :editorDataClone="this.editorDataClone"/>
        <ModalSelectSendMailAndZaloTemplate ref="ModalSelectSendMailAndZaloTemplate"/>
        <ModalSelectOptionExport ref="ModalSelectOptionExport" @export="exportFiles"/>
    </AppPermission>
</template>

<script>
    import {$alert, $get, $post, clone, setArray, getSearchQuery, removeVietnameseTones} from "@/lib/utils";
    import http from '@/services/api';
    import ModalRequestAbort from './ModalRequestAbort.vue'
    // new import
    import InputQuickSearch from "@/components/forms/InputQuickSearch.vue";
    import SelectField from "../../components/SelectField.vue";
    import Pagination from "@/components/Pagination";
    import emitter from "@/lib/emitter";
    import TableSortField from "@/components/TableSortField";
    import store from "@/store";
    import router from "@/router/index";
    import InputSelectSearch from "@/components/forms/InputSelectSearch.vue";
    import DateRangePicker from "@/components/DateRangePicker";
    import InputDateRangePicker from "../../components/forms/InputDateRangePicker";
    import SelectSearch from "@/components/SelectSearch.vue";
    import ModalSelectPrintTemplate from '@/components/ModalSelectPrintTemplate';
    import PrintTemplate from '@/components/PrintTemplate';
    import printTransactionMixin from "@/printTransactionMixin";    
    import AppPermission from '@/components/AppPermission.vue';
    import ModalSelectSendMailAndZaloTemplate from '@/components/ModalSelectSendMailAndZaloTemplate.vue';  
    import { mapGetters } from "vuex";
    import exportMixin from '@/exportMixin';
    import ModalSelectOptionExport from '@/components/ModalSelectOptionExport.vue';
    export default {
        name: "RequestIndex",
        mixins: [printTransactionMixin, exportMixin],
        components: {
            TableSortField, 
            InputQuickSearch, 
            SelectField, 
            Pagination, 
            InputSelectSearch, 
            DateRangePicker, 
            InputDateRangePicker, 
            SelectSearch,
            ModalRequestAbort,
            PrintTemplate,
            ModalSelectPrintTemplate,AppPermission,
            ModalSelectSendMailAndZaloTemplate,
            ModalSelectOptionExport
        },        
        mounted() {
            document.title = this.$t('message.RequestIndex.title') + ' | OmiPos';
            const fields = localStorage.getItem('requestSelectedFields_' + this.user.id);            
            if (fields) {
                this.fields = JSON.parse(fields);
            }
            const query = clone(this.$route.query);
            if(query['code'] != null){
                this.filterQuery['code_request'] = query['code'];
                this.loadDetail();
            }else{
                this.clearFilter();
            }
            // window.addEventListener('scroll', this.onScroll);
        },
        data() {
            const query = getSearchQuery();
            const globalConfig = store.state.GlobalConfig;
            return {
                exEntries:[],
                filter: {
                    keyword: query.keyword,
                    type: [],
                    status: [],
                    toBranchId: '',
                    fromBranchId: '',
                    statusReceive: '',
                    typeRecord: '',
                    time: null,
                    timePicker: null,
                    transferToBranch: null,
                    requestToBranch: null,
                    code_request: '',
                    product_name: '',
                    product_code: '',
                    note: '',
                },
                checkedAll: false,
                fields: [],
                entries: [],
                sortData: {
                    field: 'id',
                    direction: 'desc',
                },
                paginate: {
                    currentPage: parseInt(query.page) || 1,
                    lastPage: 1
                },
                paginateDetail: {
                    currentPage: 1,
                    lastPage: 1,
                    totalRecord: 1,
                },
                numberRecord: 15,
                statusOptions: [],
                fixed: false,
                user: store.state.Auth.user,
                arrayChecked: [],
                loading: false,
                defaultTransfer:{
                    filter: null,
                    all: null,
                    searchCode: '',
                    searchName: '',
                },
                transferActive: null,
                fieldTransferDetail : [],
                branchId: store.state.CurrentBranch.id,
                branches: globalConfig.branches,
                branchEdit: null,
                sortTime: 0,
                optionSelect: {
                    transferBranch: false,
                    requestBranch: false,
                    deliveryDate: false,
                    receivedDate: false,
                },
                listStatusTransfer: [],
                optionSttGive: [
                    {id: 0, value: 0, label: this.$t('message.common.all')},
                    {id: 1, value: 1, label: this.$t('message.common.joint')},
                    {id: 2, value: 2, label: this.$t('message.common.noJoint')},
                ],
                filterQuery: {
                    status: [],
                    receiveStatus: 0,
                },
                isFilter: false,
            }
        },
        methods: {
            async sendMailAndZalo() {
                this.$refs.ModalSelectSendMailAndZaloTemplate.show(this.$constant.TabRequestPDF, this.$constant.typeTransferProducts, this.arrayChecked);
            },
            async getTemplatePrint(entry) {  
                const res = await $get(`/v1/print-templates/get-content-print-cli`,{action: this.$constant.TabTransfers});               
                if(res && res.status.code == 200){
                    if(res.result) {                    
                        this.$refs.ModalSelectPrintTemplate.show(res.result, entry);
                    }
                }  
            },
            async updateContent(data){
                this.content = data.content;
                await this.print(data.dataPrint);          
            },
            async print(entry) { 
                this.editorDataClone =  '';
                let dataPrint = this.dataPrint(entry);  
                this.editorDataClone = await this.renderData(dataPrint);
                this.$refs.PrintTemplate.multiplePrint(this.editorDataClone);
            },
            confirmTicket(ticketId) {
                router.push({name: 'ConfirmRequestBranch', params: {id: ticketId}, query: {action: this.$constant.actionConfirmTransfer}});
            },
            createTicket() {
                router.push({name: 'RequestTransferBranch'});
            },
            editTicket(ticketId) {
                router.push({name: 'EditRequestTransferBranch', params: {id: ticketId}});
            },
            async clearFilter() {
                await this.$router.replace({
                    path: '/request/index',
                    query: {}
                });

                Object.keys(this.filter).forEach(key => {
                    this.filter[key] = '';
                });
                Object.keys(this.filterQuery).forEach(key => {
                    if(key == 'status'){
                        this.filterQuery[key] = [1,2,3,5];
                    }else if(key == 'receiveStatus'){
                        this.filterQuery[key] = 0;
                    }else{
                        this.filterQuery[key] = '';
                    }
                });
                Object.keys(this.optionSelect).forEach(key => {
                    this.optionSelect[key] = false;
                });
                emitter.emit("clearQuickSearch");
                emitter.emit("clearDateRangePicker");
                emitter.emit("clearSelectSearchValue");
                this.arrayChecked = [];
                this.numberRecord = 15;
                this.sortTime = 0;
                this.transferActive = null;
                this.isFilter = false;
                await this.load();
            },
            async filterTime(time = null, option){
                const query = clone(this.filterQuery);
                delete query['time'];
                if(time){
                    query['time'] = time;
                    query['page'] = 1;
                    if(option == 1){
                        emitter.emit("clearDataDateRangePicker");
                        this.sortTime = 1;
                        this.filter.timePicker = time;
                    }else{
                        this.filter.timePicker = null;
                        this.sortTime = 0;
                        this.filter.time = time;
                    }
                }
                this.filterQuery = {...query};
                this.isFilter = true;
                await this.load();
            },
            refreshDatePicker(option){
                switch (option) {
                    case 0:
                        this.filterTime(this.filter.time);
                        break;
                    case 1:
                        this.filterTime(this.filter.timePicker, 1);
                        break;
                }
            },
            isCheckedAll(){
                let getChecked = 0;
                this.entries.forEach((entry) => {
                    const found = this.arrayChecked.find(id => id === entry.id);
                    if(found){
                        getChecked += 1;
                        entry.checked = true;
                    }
                });

                if(getChecked > 0 && getChecked == this.entries.length){
                    this.checkedAll = true;
                }else{
                    this.checkedAll = false;
                }
            },
            countChecked(id){
                let arr = this.arrayChecked;
                if(arr.includes(id)){
                    arr = arr.filter(item => item !== id)
                }else{
                    arr.push(id)
                }
                this.arrayChecked = arr;
                this.isCheckedAll();
            },
            removeChecked(){
                this.arrayChecked = [];
                this.isCheckedAll();
            },
            onCheckedAll(value) {
                setArray(this.entries, {
                    checked: value
                });
                if(value == true){
                    this.entries.forEach(entry => {
                        const found = this.arrayChecked.find(id => id === entry.id);
                        if(!found){
                            this.countChecked(entry.id);
                        }
                    })
                }else{
                    this.entries.forEach(entry => {
                        this.countChecked(entry.id);
                    })
                }
            },
            getCheckedIDs() {
                return this.entries.filter(e => e.checked).map(e => e.id);
            },
            async doFilter(field, value) {
                const query = clone(this.filterQuery);
                if(field == 'status'){
                    // let arr = query['status'];
                    if(query['status'].includes(value)){
                        query['status'] = query['status'].filter(item => item !== value)
                    }else{
                        query['status'].push(value)
                    }
                    // this.filterQuery.status = arr;
                }else{
                    query[field] = value;
                }
                query['page'] = 1;
                this.filterQuery = {...query};
                this.isFilter = true;
                await this.load();
            },
            async sort(field, direction) {
                this.sortData = {
                    field, direction
                };

                const query = clone(this.$route.query);
                query.sort_field = field;
                query.sort_direction = direction;

                await this.$router.push({query: query});
                await this.load();


            },
            isExistInArrayChecked(entry, array = []){
                if(array.includes(entry.id)){
                    entry.checked = true;
                    return true;
                }else{
                    entry.checked = false;
                    return false;
                }
            },
            onMouseLeave(){
                emitter.emit("mouseleave");
            },
            async pageChange(page) {
                const query = clone(this.filterQuery);
                query['page'] = page;
                this.isFilter = true;
                this.filterQuery = {...query};
                this.load();
            },
            async onChange(v) {
                this.numberRecord = v.target.value
                let query = clone(this.filterQuery);
                query['page'] = 1;
                this.isFilter = true;
                this.filterQuery = {...query};
                this.load();
            },
            async load(query = null) {
                this.loading = true;
                emitter.emit("onLoading");
                const filterQuery =  query ? query : this.filterQuery;
                const res = await $post('/v1/request/data', {...this.$route.query, ...filterQuery, ...this.optionSelect, record: this.numberRecord, branchId: this.branchId});
                if (res.result.code !== 200) {
                    $alert(res);
                    return;
                }                
                //Phục vụ cho export tổng quang không qua phân trang
                this.exEntries = [];  
                
                if (!this.fields || !this.fields.length) {
                    this.fields = res.result.data.fields;
                }
                // this.paginate = res.result.data.paginate;
                // this.entries = res.result.data.entries;
                this.entries = res.result.data.data.data;       
                this.paginate.totalRecord = res.result.data.data.total;
                this.paginate.currentPage = res.result.data.data.current_page;
                this.paginate.lastPage = res.result.data.data.last_page;
                this.listStatusTransfer = res.result.data.listStatus;
                this.fieldTransferDetail = res.result.data.listFieldDetailProduct ?? [];
                this.isCheckedAll();
                emitter.emit("offLoading");
                this.loading = false;
            
            },
            async loadDetail(){
                emitter.emit("clearDateRangePicker");
                emitter.emit("clearSelectSearchValue");
                await this.load();
                this.entries.forEach((entry) => {
                    this.detailRequest(entry.id, entry);
                });
            },
            onScroll() {
                let height = window.scrollY;
                if(height > 120){
                    //Giữ vị trí cho thông báo lỗi    
                    this.fixed = true;
                }else{
                    this.fixed = false;
                }
                emitter.emit("position", 0);
            },  
          
            detailRequest(id, entry){
                if (id === this.transferActive) {
                    this.transferActive = null;
                } else {
                    this.transferActive = id;
                }
                this.defaultTransfer.filter = this.defaultTransfer.all = entry.details;
                this.setPaginate();
            },
            onInputFilterTransferDetail(field){
                this.paginateDetail.currentPage = 1;
                if(this.defaultTransfer.searchCode.length == 0 && this.defaultTransfer.searchName.length == 0){
                    this.defaultTransfer.filter = this.defaultTransfer.all;
                    this.setPaginate();
                    return;
                }
                let arr = [];
                switch (field) {
                    case 'searchCode':
                        for (let index = 0; index < this.defaultTransfer.all.length; index++) {
                            if (this.defaultTransfer.all[index] != null && removeVietnameseTones(this.defaultTransfer.all[index].productCode.toLowerCase()).indexOf(removeVietnameseTones(this.defaultTransfer.searchCode.toLowerCase())) > -1){
                                arr.push(this.defaultTransfer.all[index]);
                            }
                        }
                        break;
                    case 'searchName':
                        for (let index = 0; index < this.defaultTransfer.all.length; index++) {
                            if (this.defaultTransfer.all[index] != null && removeVietnameseTones(this.defaultTransfer.all[index].productName.toLowerCase()).indexOf(removeVietnameseTones(this.defaultTransfer.searchName.toLowerCase())) > -1){
                                arr.push(this.defaultTransfer.all[index]);
                            }
                        }
                        break;
                }
                this.defaultTransfer.filter = arr;
                this.setPaginate();
            },
            setPaginate(){
                this.paginateDetail.currentPage = 1;
                this.paginateDetail.lastPage = Math.ceil(this.defaultTransfer.filter.length / 10);
                this.paginateDetail.totalRecord = this.defaultTransfer.filter.length;
            },
            resetValue(branchId){
                this.branchEdit = branchId;
            },
            async quickSaveTransfer(entry){
                if(entry.fromBranchId == this.branchEdit){
                    const data = {
                        code: 422,
                        message: this.$t('message.common.inValidRequestedBranch'),
                    }
                    $alert(data);
                    return;
                }else{
                    if(entry.receiveDescription?.length > 255 && this.branchId == entry.fromBranchId){
                        $alert({
                            code: 422,
                            message: this.$t('message.common.maxLengthRequestBranchNote'),
                        });
                    }else if(entry.sendDescription?.length > 255 && this.branchId == entry.toBranchId){
                        $alert({
                            code: 422,
                            message: this.$t('message.common.maxLengthRequestedBranchNote'),
                        });
                    }else{
                        const res = await $post('/v1/request/quick-save', {
                            id: entry.id, 
                            toBranchId: this.branchEdit != null ? this.branchEdit : entry.toBranchId, 
                            sendDescription: entry.sendDescription, 
                            receiveDescription: entry.receiveDescription
                        });
                        if(res.result.status == true){
                            $alert({
                                code: 200,
                                message: this.$t('message.common.updateRequestSuccess'),
                            });
                            this.load();
                        }
                    }
                    
                }
            },
            changeSelect(obj){
                this.optionSelect[obj] = !this.optionSelect[obj];
                const query = clone(this.filterQuery);
                query['page'] = 1;
                this.filterQuery = {...query};
                this.load();
            },
            showHide(name,iDown, iUp){
                var dropdownContent = document.getElementById(name);
                dropdownContent.classList.toggle("dp-hide");
                var down = document.getElementById(iDown);
                down.classList.toggle("dp-hide");
                var up = document.getElementById(iUp);
                up.classList.toggle("dp-hide");
            },
            async changeQuickSearch(object){
                const query = clone(this.filterQuery);
                Object.keys(this.filter).forEach(key => {
                    object.forEach(obj => {
                        Object.keys(obj).forEach(o => {
                            if(key == o && obj[o] != ''){
                                this.filter[key] = obj[o];
                                query[o] = obj[o];
                            }else if(key == o && obj[o] == ''){
                                delete query[o];
                            }
                        });
                    })
                });
                query['page'] = 1;
                this.isFilter = true;
                this.filterQuery = {...query};
                this.load();
            },
            //Xuất file
            getOSByID(entries){              
                return entries;
            },
            selectOptionExport(method = 'exOverview'){
                let params = { method: method };
                this.$refs.ModalSelectOptionExport.show(params, this.paginate.totalRecord, this.fields);
            },
            async exportFiles(params){
                if (params.method) {
                    this[params.method](params.firstRecordIndex);
                }
            },
            async exOverview(firstRecordIndex = 0) {
                emitter.emit("onLoading");
                const res = await http.download('/v1/transfers/request/exOverview', {
                    fields: this.fields, 
                    firstRecordIndex: firstRecordIndex,
                    ...this.$route.query, 
                    ...this.filterQuery, 
                    ...this.optionSelect,
                });            
                this.returnDataExport(res);
            },  
            copyRequestById(id){                        
                 router.push({ name: 'CopyRequestTransferBranch', query: { id: id, type: 'copy' }});               
            }, 
            async exSelectOverview() {
                emitter.emit("onLoading");
                const res = await http.download('/v1/transfers/request/exOverview', {
                    fields: this.fields,
                    id: this.arrayChecked
                });
                this.returnDataExport(res);
            },  
            async exSelectDetails() {
                emitter.emit("onLoading");
                const res = await http.download('/v1/transfers/request/exDetails', {
                    fields: this.fields, 
                    id: this.arrayChecked
                });
                this.returnDataExport(res);
            },
            async exDetails(firstRecordIndex = 0) {
                emitter.emit("onLoading");
                const res = await http.download('/v1/transfers/request/exDetails', {
                    fields: this.fields, 
                    firstRecordIndex: firstRecordIndex,
                    ...this.$route.query, 
                    ...this.filterQuery, 
                    ...this.optionSelect,
                });
                this.returnDataExport(res);
            },   
            async exRequestById(id){
                emitter.emit("onLoading");
                const res = await http.download('/v1/transfers/request/exById/' + id, {...this.fields});                
                this.returnDataExport(res);
            }, 
            ShowModalRequestAbort(id, code){
                this.$refs.ModalRequestAbort.show(id, code);                
            },      
            doFilterSearch(v){
                const query = clone(this.filterQuery);
                delete query[v.label];
                if(v.model){
                    query[v.label] = v.model;
                }
                query['page'] = 1;
                this.isFilter = true;
                this.filterQuery = {...query};
                this.load();
            },
        },
        computed: {
            ...mapGetters({
                statusEmail: 'settingStore/email',
            }),
        },
    }
</script>

<style scoped>
#number_records {
  margin-top: 11px;
}
.container input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.text-title {
  line-height: 52px;
}

#typeCard {
  margin-top: -8px;
}
#noteRO {
    border-left: 1px solid #ccc;
}
#fa_edit {
    position: absolute;
    left:20px;
    top:4px;
    color:#a7a2a2;
}
.noteStyle {
    width: 100% !important;
    height: 80px !important;
    border: 0;
    border-radius: 0;
}

.noteStyle:focus {
    outline: none !important;
    border-color: none;
    box-shadow: 0 none;
}
</style>
